const module = { name: 'Fandango/triggerEvent', exports: {} }; const exports = module.exports;



import { Fandango as Fandango } from 'require-core';

function triggerAnalyticsEvent(event, eventData = {}) {
    const { account: { isLoggedIn, }, analyticsData: { customerGUID, deviceType, pageName: contextPageName, pageType: contextPageType, server: serverApp }, context: { device: { isMobile, }, }, } = Fandango;
    const { pageName = contextPageName, pageType = contextPageType, productType, productId, server = serverApp, event: eventFromData, ...extraEventData } = eventData;
    window.dataLayer = window.dataLayer || [];
    const payload = {
        event: eventFromData || event,
        businessProperty: 'fandango',
        customerGUID,
        deviceType,
        loggedInStatus: isLoggedIn,
        platform: isMobile ? 'fandango mobile web' : 'fandango web',
        server,
        ...extraEventData
    };
    if (pageName) {
        payload.pageName = pageName;
    }
    if (pageType) {
        payload.pageType = pageType;
    }
    if (productType) {
        payload.productType = productType;
    }
    if (productId) {
        payload.productId = productId;
    }
    window.dataLayer.push(payload);
}


const exportedIsMobile = Fandango?.context?.device?.isMobile === true
module.exports = {
    triggerAnalyticsEvent,
    isMobile: exportedIsMobile
};
export default module.exports;